import { useCompanyId } from "@/entities/company/hooks/use-company-id";
import { useFetchCurrentUserQuery } from "@/entities/user/api/fetch-current-user";
import { isCurrentUserOwner } from "@/entities/user/lib/user-utils";

export const useIsOwner = () => {
  const companyId = useCompanyId();
  const currentUser = useFetchCurrentUserQuery({ companyId });
  const isOwner = isCurrentUserOwner({ user: currentUser });

  return { isOwner };
};
